import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const options = [{
  title: 'Driver Recruiting',
  desc: "For fleets that can't find or keep enough of the right drivers.",
  cta: 'Fix Recruiting Bottlenecks'
}, {
  title: 'Dispatch & Load Management',
  desc: 'For teams stuck reacting load-to-load instead of planning profitable movement.',
  cta: 'Improve Dispatch Rhythm'
}, {
  title: 'Back Office & Cash Flow',
  desc: 'For companies losing time and money to paperwork, billing delays, and manual reconciliation.',
  cta: 'Clean Up Back Office'
}, {
  title: 'Compliance & Risk',
  desc: 'For teams that need cleaner documentation, safety rhythm, and operational discipline.',
  cta: 'Reduce Risk'
}, {
  title: 'Technology & Data',
  desc: 'For businesses with too many disconnected systems and not enough visibility.',
  cta: 'Improve Visibility'
}, {
  title: 'Growth Consulting',
  desc: 'For owners who need a complete plan to scale without adding chaos.',
  cta: 'Build My Growth Plan'
}];
export function HelpFirst() {
  return <section className="section-padding bg-white" data-id="element-211">
      <div className="container-custom" data-id="element-212">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-213">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-navy mb-6" data-id="element-214">
            Where Is the Bottleneck Showing Up First?
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-215">
          {options.map((opt, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-off-white border border-steel p-8 rounded-sm flex flex-col h-full group hover:border-navy transition-colors" data-id="element-216">
              <h3 className="text-xl font-bold font-heading text-navy mb-3" data-id="element-217">
                {opt.title}
              </h3>
              <p className="text-body/80 mb-8 flex-grow" data-id="element-218">{opt.desc}</p>
              <a href="#contact" className="inline-flex items-center text-red font-bold uppercase tracking-wider text-sm group-hover:text-navy transition-colors mt-auto" data-id="element-219">
                {opt.cta}
                <ArrowRight className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform" data-id="element-220" />
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}